
import { Component, EventEmitter, Input, OnInit, Output, ChangeDetectionStrategy } from "@angular/core";
import { ManagerCommentReview, Review } from "../../taskbook-triage/taskbook.types";
import { UserInfos } from "../../shared/ui/username-icon/user-infos.type";
import { RichTextComment, ThreadAuthor } from "@teammood/timeline";
import { Delta } from "quill";

@Component({
    selector: 'manager-comment-review',
    templateUrl: './manager-comment-review.component.html',
    styleUrls: ['./manager-comment-review.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false,
})
export class ManagerCommentReviewComponent implements OnInit {

    protected managerCommentUpdateMode: boolean = false;
    protected managerListForMentions: ThreadAuthor[] = [];

    @Input() userInfos: UserInfos;
    @Input() userId: string;
    @Input() review: ManagerCommentReview;
    @Input() commentAuthors: ThreadAuthor[];

    @Output()
    private onReviewCommentDeleted = new EventEmitter<Review>();
    @Output()
    private onReviewCommentEdited = new EventEmitter<ManagerCommentUpdate>();

    constructor(
    ){}

    ngOnInit(): void {
        this.managerListForMentions = this.commentAuthors.filter(commentAuthor => commentAuthor.id !== this.userId);
    }

    protected editManagerCommentReview(){
        this.managerCommentUpdateMode = true;
    }

    protected deleteManagerCommentReview(reviewComment: Review){
        this.onReviewCommentDeleted.next(reviewComment);
    }

    protected onCommentEdited(message: RichTextComment){
        this.managerCommentUpdateMode = false;
        const reviewComment: ManagerCommentUpdate = { review:this.review, updatedComment: message.objectModelFormat};
        this.onReviewCommentEdited.next(reviewComment);
    }
}

export interface ManagerCommentUpdate {
    review: Review
    updatedComment: Delta
}